import client from '../httpClient';

const lineAddNewIdApi = (params) => {
  return client.post('/line-rooms', JSON.stringify(params));
};

export default lineAddNewIdApi;
